export default {
  path: "/SectionContent/SubmittingCrashReport",
  name: "Submitting a Crash Report",
  htmlContent: "submitting_a_crash_report.html",
  headings: [
    { id: "SubmissionGuidelines", text: "Submission Guidelines", type: "heading" },
    {
      id: "CrashReportCompletionAssistance",
      text: "Crash Report Completion Assistance",
      type: "heading",
    },
    {
      id: "CorrectingAPreviouslySubmittedReport",
      text: "Correcting a Previously Submitted Report",
      type: "heading",
    },
    { id: "SupplementToOriginalReport", text: "Supplement to Original Report", type: "heading" },
    {
      id: "ElectronicCrashReportDatabase",
      text: "Electronic Crash Report Database",
      type: "heading",
    },
  ],
};
